import { useFormik } from 'formik';
import { useEffect } from 'react';
import { ProcedureParams } from '../../../../../../shared/types/systemConfiguration/procedureParams';

export const useProcedureRegisterHistory = (procedure?: ProcedureParams) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = procedure || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [procedure]);

    return {
        formik,
    };
};
